export default class Carousel {
    constructor($element) {
        this.$element = $element;
        this.$track = $element.querySelector('[data-carousel-track]');
        this.$slides = Array.from($element.querySelectorAll('[data-carousel-slide]'));
        this.$prev = $element.querySelector('[data-carousel-prev]');
        this.$next = $element.querySelector('[data-carousel-next]');
        this.currentPage = 0;

        if (!this.$track || this.$slides.length === 0) {
            return;
        }

        this.handleResize = this.handleResize.bind(this);

        this.bindEvents();
        this.handleResize();
    }

    /* -- INIT -- */

    bindEvents() {
        if (this.$prev) {
            this.$prev.addEventListener('click', () => this.goToPage(this.currentPage - 1));
        }

        if (this.$next) {
            this.$next.addEventListener('click', () => this.goToPage(this.currentPage + 1));
        }

        window.addEventListener('resize', this.handleResize, { passive: true });
    }

    /* -- STATE -- */

    getVisibleCount() {
        if (this.isDesktopGrid()) {
            return this.$slides.length;
        }

        if (window.innerWidth >= 992) {
            return this.getConfiguredVisibleCount('desktop', 4);
        }

        if (window.innerWidth >= 768) {
            return this.getConfiguredVisibleCount('tablet', 3);
        }

        if (window.innerWidth >= 480) {
            return this.getConfiguredVisibleCount('small', 2);
        }

        return this.getConfiguredVisibleCount('mobile', 1);
    }

    getConfiguredVisibleCount(breakpoint, fallback) {
        const value = parseInt(this.$element.dataset[`carouselVisible${breakpoint.charAt(0).toUpperCase()}${breakpoint.slice(1)}`], 10);

        return Number.isNaN(value) || value < 1 ? fallback : value;
    }

    getPageCount() {
        return Math.max(1, this.$slides.length - this.getVisibleCount() + 1);
    }

    isDesktopGrid() {
        return this.$element.dataset.carouselGridDesktop === 'true' && window.innerWidth >= 992;
    }

    goToPage(page) {
        const maxPage = this.getPageCount() - 1;
        this.currentPage = Math.max(0, Math.min(page, maxPage));
        this.render();
    }

    handleResize() {
        const maxPage = this.getPageCount() - 1;
        this.currentPage = Math.min(this.currentPage, Math.max(0, maxPage));
        this.render();
    }

    /* -- RENDER -- */

    render() {
        const firstSlide = this.$slides[0];
        if (!firstSlide) {
            return;
        }

        if (this.isDesktopGrid()) {
            this.$track.style.transform = 'translate3d(0, 0, 0)';
            this.$slides.forEach($slide => $slide.classList.add('is-active'));

            if (this.$prev) {
                this.$prev.disabled = true;
            }

            if (this.$next) {
                this.$next.disabled = true;
            }

            return;
        }

        const slideStyle = window.getComputedStyle(firstSlide);
        const gap = parseFloat(window.getComputedStyle(this.$track).columnGap || window.getComputedStyle(this.$track).gap || '0');
        const slideWidth = firstSlide.getBoundingClientRect().width
            + parseFloat(slideStyle.marginRight || '0')
            + gap;

        this.$track.style.transform = `translate3d(${-1 * this.currentPage * slideWidth}px, 0, 0)`;

        const visibleCount = this.getVisibleCount();
        this.$slides.forEach(($slide, index) => {
            const isActive = index >= this.currentPage && index < this.currentPage + visibleCount;
            $slide.classList.toggle('is-active', isActive);
        });

        if (this.$prev) {
            this.$prev.disabled = this.currentPage === 0;
        }

        if (this.$next) {
            this.$next.disabled = this.currentPage >= this.getPageCount() - 1;
        }
    }
}
